import { Block, Flex } from '@aloft/toolkit-sui';

import { memo, useMemo } from 'react';

import { PropertyGrid } from '../../components/PropertyGrid/PropertyGrid.tsx';
import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { FeatureGridDataSourcesSection } from './columnSections/FeatureGridDataSourcesSection.tsx';
import { FeatureGridFeatureSections } from './columnSections/FeatureGridFeatureSections.tsx';
import { FeatureGridMainDwellingSection } from './columnSections/FeatureGridMainDwellingSection.tsx';
import { FeatureGridSiteSection } from './columnSections/FeatureGridSiteSection.tsx';
import { FeatureGridTransactionSection } from './columnSections/FeatureGridTransactionSection.tsx';
import { FeatureGridLabelColumnHeader } from './components/FeatureGridLabelColumnHeader.tsx';
import { FeatureGridToolbar } from './components/FeatureGridToolbar.tsx';

export const FeatureGridModule = memo(() => {
  const columnSections = useMemo(
    () => [
      FeatureGridDataSourcesSection,
      FeatureGridTransactionSection,
      FeatureGridSiteSection,
      FeatureGridMainDwellingSection,
      FeatureGridFeatureSections,
    ],
    [],
  );

  return (
    <Flex
      {...useTkv2ReferenceBarEvents()}
      flexDirection="column"
      overflow="hidden"
      width="100%"
      gap="8px"
    >
      <FeatureGridToolbar />
      <Block overflow="auto" paddingRight="10px">
        <PropertyGrid
          gridType="FeatureGrid"
          columnSections={columnSections}
          labelColumnHeader={<FeatureGridLabelColumnHeader />}
        />
      </Block>
    </Flex>
  );
});
